import * as React from "react";
import { ButtonLink } from "../atoms/button-link";
import { Card } from "./card";

export const SignupLink = () => {
  return (
    <Card title={"Grafferアカウントをお持ちでない方"}>
      <p className="mb-4">
        Grafferアカウントに登録すると、申請書の一時保存や申請履歴の確認ができます。アカウント登録は無料です。
      </p>
      <div className="mb-2">
        <ButtonLink
          href={`/signup${window.location.search}`}
          text={`新規アカウント登録`}
        />
      </div>
    </Card>
  );
};
